import { ColDef } from '@ag-grid-community/core'

export const RvAttributionBySectorColumns: ColDef[] = [
  {
    field: 'group1',
    suppressMovable: true,
    lockPosition: true,
    pinned: 'left',
    valueGetter: (params: any) => {
      if (params.node.level === -1) {
        return 'Total'
      }
      return params.data.group1
    },
  },
  {
    field: 'port_weight',
    aggFunc: 'sum',
  },
  {
    field: 'bench_weight',
    aggFunc: 'sum',
  },
  {
    field: 'active_weight',
    aggFunc: 'sum',
  },
  {
    field: 'port_total_return',
  },
  {
    field: 'bench_total_return',
  },
  {
    field: 'active_return',
  },
  {
    field: 'allocation_low1',
    aggFunc: 'sum',
  },
  {
    field: 'selection_effect1',
    aggFunc: 'sum',
  },
  {
    field: 'active_currency_return1',
    aggFunc: 'sum',
  },
  {
    field: 'port_total_return_contrib',
    aggFunc: 'sum',
  },
  {
    field: 'bench_total_return_contrib',
    aggFunc: 'sum',
  },
]
